module.exports = __webpack_public_path__ + "static/img/head_bg.71de5c77.png";